<mat-card *ngIf="hasAlternativeOptionForRelease()">
	<mat-card-content>
		<div class="treatment-title">
			<h3>
				<i class="fas fa-arrow-alt-circle-up"></i>
				{{'Alternative Option' | translate}} - {{getAlternativeOptionProductName()}}
			</h3>
		</div>
			<ux-treatment-packages class="alternative-option-packages"
								[treatment]="treatment"
								[packages]="treatment.upgrade.packages"
			></ux-treatment-packages>
	</mat-card-content>
</mat-card>

@if (releaseData) {
<mat-card>
	<mat-card-content>
		<h2>{{'PleaseRelease' | translate}}</h2>
		<h3>{{'ReleaseFiles' | translate}}</h3>
		<div class="files-container">
			<div class="grid-row">
				<span>{{'Anamnestische Checkliste PDF' | translate}}</span>
				<a (click)="openQuestionaireDialog()"
						mat-button
						color="default">
						<i class="fal fa-arrow-to-bottom"></i> {{'Download' | translate}}
				</a>
			</div>
			@for (file of releaseData.releaseFiles; track $index) {
				<div class="grid-row">
					<span>{{file.name}}</span>
					<a (click)="downloadMediaFile(file.id)"
						mat-button
						color="default"
					>
						<i class="fal fa-arrow-to-bottom"></i> {{'Download' | translate}}
					</a>
				</div>
			}
			@if(releaseData.release?.webViewerUrl){
				<div class="grid-row">
					<span>{{"WebViewer Link" | translate}}</span>
					<button mat-button color="default" ngxClipboard
							title="{{releaseData.release.webViewerUrl}}"
							[cbContent]="releaseData.release.webViewerUrl">
						<i class="fal fa-sign-in-alt"></i> {{'Zwischenablage' | translate}}
					</button>
				</div>
			}
			@if(releaseData.release?.webViewerUrlUpgrade){
				<div class="grid-row">
					<span>{{"WebViewer Link" | translate}} ({{"Alternative Option" | translate}})</span>
					<button mat-button color="default" ngxClipboard
							title="{{releaseData.release.webViewerUrlUpgrade}}"
							[cbContent]="releaseData.release.webViewerUrlUpgrade">
						<i class="fal fa-sign-in-alt"></i> {{'Zwischenablage' | translate}}
					</button>
				</div>
			}
		</div>
		<div *ngIf="releaseData.release?.technicianComment?.comment">
			<h3>{{'Anmerkung des Technikers' | translate}}</h3>
			<p class="technician-comment">
				@if(releaseData.release?.technicianComment?.date){
					{{releaseData.release.technicianComment.date| date: 'mediumDate' : 'EUROPE/BERLIN' : config.locale}} :
				}
				{{releaseData.release?.technicianComment.comment}}</p>
		</div>
	</mat-card-content>
</mat-card>
}

<ux-ca-webviewer></ux-ca-webviewer>

<div class="controls">
	<button mat-raised-button (click)="onBackButtonClicked()" [disabled]="processing">
		<i class="fal fa-chevron-double-left"></i> {{'Back' | translate}}
	</button>
	<button *ngIf="hasRequestedOptionForRelease()" (click)="onRelease()" [disabled]="processing" mat-raised-button
		color="primary">
		{{'Setup Freigabe' | translate}}
	</button>
	<button *ngIf="hasAlternativeOptionForRelease()" (click)="onReleaseAlternativeOption()" [disabled]="processing" mat-raised-button
		color="primary">
		{{'Alternative freigeben' | translate}}
	</button>
	<button (click)="onCorrection()" mat-raised-button [disabled]="processing">
		{{'Setup Korrektur' | translate}}
	</button>
	<button (click)="onCancel()" [disabled]="processing" mat-raised-button>
		{{'Storno' | translate}}
	</button>
</div>
